"use client";

import React from "react";

/**
 * ButtonGroup - Groups buttons together.
 */
export function ButtonGroup({ children, className = "", size, vertical, ...props }) {
  return (
    <div
      className={`inline-flex ${vertical ? "flex-col" : "flex-row"} [&>*]:rounded-none ${vertical ? "[&>*:first-child]:rounded-t [&>*:last-child]:rounded-b" : "[&>*:first-child]:rounded-l [&>*:last-child]:rounded-r"} ${vertical ? "[&>*]:-mt-px first:[&>*]:mt-0" : "[&>*]:-ml-px first:[&>*]:ml-0"} ${className}`.trim()}
      role="group"
      {...props}
    >
      {children}
    </div>
  );
}
